import { useEffect, useMemo, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import ReactQuill from 'react-quill';
import "quill-mention";
import 'react-quill/dist/quill.snow.css'
import "quill-mention/dist/quill.mention.css";
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';
const Styles = styled.div`
    /* Desactivar traducción automática del navegador */
    .ql-editor {
        translate: no;
    }
    
    /* Asegurar que el contenedor tenga position relative */
    position: relative;
    
    .ql-toolbar{
        padding-bottom: 15px;
    }
    .ql-container{
        border-bottom-left-radius: 0.5em;
        border-bottom-right-radius: 0.5em;
        color: #000;
        position: relative;
    }
    .ql-editor{
        height: 180px;
    }
    .ql-container.ql-snow{
        background: #fff;
    }
    .ql-snow.ql-toolbar {
        display: block;
        background: #e6f0ff;
        border-top-left-radius: 0.5em;
        border-top-right-radius: 0.5em;
        position: sticky!important;
        top: 0;
        z-index: 1;
    }
    
    /* Tooltip/diálogo para insertar links - con z-index muy alto */
    .ql-tooltip {
        z-index: 999999 !important;
        position: fixed !important;
        background: white !important;
        border: 1px solid #ccc !important;
        box-shadow: 0 8px 24px rgba(0,0,0,0.25) !important;
        padding: 12px 16px !important;
        border-radius: 6px !important;
        left: 50% !important;
        top: 50% !important;
        transform: translate(-50%, -50%) !important;
    }
    
    /* Mantener el comportamiento por defecto de Quill para ocultar */
    .ql-tooltip.ql-hidden {
        display: none !important;
    }
    
    .ql-tooltip input[type="text"] {
        width: 250px !important;
        padding: 8px 10px !important;
        border: 1px solid #ccc !important;
        border-radius: 4px !important;
        font-size: 14px !important;
        outline: none !important;
    }
    
    .ql-tooltip input[type="text"]:focus {
        border-color: #0364ff !important;
        box-shadow: 0 0 0 2px rgba(3, 100, 255, 0.1) !important;
    }
    .ql-tooltip .ql-action {
        margin-left: 8px !important;
        cursor: pointer !important;
        padding: 4px 12px !important;
        background: #0364ff !important;
        color: white !important;
        border: none !important;
        border-radius: 4px !important;
        font-size: 13px !important;
    }
    .ql-tooltip .ql-remove {
        margin-left: 8px !important;
        cursor: pointer !important;
        padding: 4px 12px !important;
        background: #dc3545 !important;
        color: white !important;
        border: none !important;
        border-radius: 4px !important;
        font-size: 13px !important;
    }
    
    .ql-tooltip .ql-action:hover {
        background: #0246cc !important;
    }
    
    .ql-tooltip .ql-remove:hover {
        background: #bb2d3b !important;
    }
    
    span.mention {
        color: blue;
        background: lightskyblue;
    }
    /* Estilos para los links */
    .ql-editor a {
        color: #0364ff;
        text-decoration: underline;
        cursor: pointer;
    }
    .ql-editor a:hover {
        color: #0246cc;
        text-decoration: underline;
    }
`;


const InputEditQuill =({onChangeText,template,id,etiqueta}) => {
    const [value, setValue] = useState(template || '')
    const users = useSelector(state => state.default.usuarioSelect);
    const hashtags = useSelector(state => state.default.hashtags);
    const [usersArr, setUsersArr] = useState([]);
    const [hashtagsArr, setHashtagsArr] = useState([]);
    const quillRef = useRef(null);

    useEffect(() => {
        if(users?.length > 0){
            setUsersArr(users);
        }
    }, [users])
    useEffect(() => {
        if(hashtags?.length > 0){
            setHashtagsArr(hashtags);
        }
    }, [hashtags])
    const searchPerson = (searchTerm) => {
        const uss =  usersArr?.filter(person => (person.value.toLowerCase()).includes(searchTerm.toLowerCase()));
        return uss;
    }
    const searchHash = (searchTerm) => {
        const uss =  hashtagsArr?.filter(hash => (hash.value.toLowerCase()).includes(searchTerm.toLowerCase()));
        return uss;
    }

    const modules = useMemo(() => ({
        mention: {
            allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
            minChars: 2,
            mentionDenotationChars: ["@",'#'],
            source: function(searchTerm, renderList,mentionChar) {
                if(mentionChar === '@'){
                    const matchedPeople = searchPerson(searchTerm);
                    renderList(matchedPeople);
                }else if(mentionChar === '#'){
                    const matchedPeople = searchHash(searchTerm);
                    renderList(matchedPeople);
                }else{
                    renderList([])
                }
            }
        },
        toolbar: [
            ['bold', 'italic', 'underline','strike'],
            [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
            [{ 'header': [2, 3, false] }],
            [{ 'align': [] }],
            [{ 'color': ['#ff0000', '#00ff00', '#0000ff', '#000000', '#ffffff'], 'default': '#ff0000' }, { 'background': [] }],
            ['link'],
            ['clean']
        ],
    }), [usersArr,hashtagsArr])
    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike',
        'list', 'bullet', 'indent','background','color','align','mention','link'
    ]
    const onChangeTemplete = (newEditor) => {
        // Validar y corregir links sin protocolo
        let correctedEditor = newEditor;
        
        // Regex para encontrar links en el HTML
        const linkRegex = /<a\s+(?:[^>]*?\s+)?href="([^"]*)"/gi;
        let match;
        
        while ((match = linkRegex.exec(newEditor)) !== null) {
            const url = match[1];
            // Si el link no tiene protocolo, agregar https://
            if (url && !url.match(/^(https?|ftp|mailto):/i)) {
                const correctedUrl = 'https://' + url;
                correctedEditor = correctedEditor.replace(
                    `href="${url}"`,
                    `href="${correctedUrl}"`
                );
            }
        }
        
        onChangeText(correctedEditor);
        setValue(correctedEditor);
    }

    useEffect(() => {
        onChangeText(template)
        setValue(template)
    }, [template])
    return (
        <Styles>
            {usersArr?.length > 0 && hashtagsArr?.length > 0 ? (
                <div translate="no" className="notranslate">
                    <ReactQuill
                        ref={quillRef}
                        id={id}
                        theme="snow"
                        value={value}
                        onChange={onChangeTemplete}
                        modules={modules}
                        formats={formats}
                    />
                </div>
            ):(
                <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <CircularProgress sx={{color: "#0364ff"}} />
                </Box>
            )}
        </Styles>
    )
}

export default InputEditQuill